'use strict';

var varint = require('varint');

function _interopNamespace(e) {
  if (e && e.__esModule) return e;
  var n = Object.create(null);
  if (e) {
    Object.keys(e).forEach(function (k) {
      if (k !== 'default') {
        var d = Object.getOwnPropertyDescriptor(e, k);
        Object.defineProperty(n, k, d.get ? d : {
          enumerable: true,
          get: function () { return e[k]; }
        });
      }
    });
  }
  n["default"] = e;
  return Object.freeze(n);
}

var varint__namespace = /*#__PURE__*/_interopNamespace(varint);

function varintEncoder(buf) {
  let out = new Uint8Array(buf.reduce((acc, curr) => {
    return acc + varint__namespace.default.encodingLength(curr);
  }, 0));
  let offset = 0;
  for (const num of buf) {
    out = varint__namespace.encode(num, out, offset);
    offset += varint__namespace.default.encodingLength(num);
  }
  return out;
}

module.exports = varintEncoder;
